import { IConsentSummary } from '../consent/consent.model';

/* Should match expectations in the iframe CDN script */
export interface IPostMessageData {
  action: 'scrolling' | 'topOfPageVisible' | 'ready' | 'waiverStarted';
  scrollingValue?: 'yes' | 'no' | 'auto';
  value?: boolean;
}

/**
 * Data received from websites embedding the checkout, posted through our CDN responsive-iframe.js script
 * For param documentation, see:
 * https://support.roller.software/hc/en-us/articles/9657999631759-Add-the-overlay-checkout-experience-to-your-website
 */
export interface IReceiveMessageData {
  section?: string;
  consent?: IConsentSummary;
  date?: string;
  isVisible: boolean | undefined;
  productId?: string;
  sessionStart?: string;
  sessionDate?: string;
  code?: string;
}

/** Array of acceptable message sources for property - filter out any unrelated iFrame messages */
export const CAcceptableDataSources = ['RollerEmbeddedCheckout'];
